import React from 'react';
import {observer} from 'mobx-react';
import {withState, t} from 'shared/core';
import {TimeOffState} from '../state';
import {Button, Panel, EmojiTitle} from 'shared/components';
import {Table} from 'main/components';
import {redirect} from 'shared/tools';
import {auth, formatTimeOffAmount} from 'main/tools';
import {FormattedMessage} from 'react-intl';

const DaysAvailable = observer(({model}) => {
  if (model.unlimited) {
    return (
      <div>
        {formatTimeOffAmount(model.logged, model.timeOffType.unit)}
        <div className='waterloo h5'>
          <FormattedMessage id='hr_dashboard.time_off.used'/>
        </div>
      </div>
    );
  }

  return (
    <div>
      {formatTimeOffAmount(model.balanceView, model.timeOffType.unit)}
      <div className='waterloo h5'>
        <FormattedMessage id='hr_dashboard.time_off.available'/>
      </div>
    </div>
  );
});

const COLUMNS = [
  {
    width: 8,
    attribute: 'timeOffType.name'
  },
  {
    width: 4,
    component: DaysAvailable
  }
];

const TimeOff = observer(({uiState}) => {
  const {sortedAccounts, Emoji} = uiState;

  return (
    <Panel>
      <Panel.Header title={<EmojiTitle Emoji={Emoji} emojiKey='palm_tree' title={t('hr_dashboard.time_off.My Time Off')}/>}/>
      <Table
        columns={COLUMNS}
        showLinks={false}
        showHeaders={false}
        models={sortedAccounts}
      />
      <Button className='mt1 full-width' onClick={() => redirect(`employees/${auth.employee.id}/time-off/request`)}>
        <FormattedMessage id='hr_dashboard.time_off.Request Time Off'/>
      </Button>
    </Panel>
  );
});

export default withState(TimeOff, TimeOffState);
